module.exports = __webpack_public_path__ + "img/check-on.fc36b1bc.svg";